<template>
  <ClientOnly>
    <VueRecaptcha
      :sitekey="recaptchaV2SiteKey"
      :language="locale"
      @verify="emit('verify', $event)" 
    />
  </ClientOnly>
</template>

<script setup lang="ts">
import { VueRecaptcha } from "recaptcha-vue";
const { locale } = useI18n();

const emit = defineEmits<{
  verify: [token: string];
}>();

const { recaptchaV2SiteKey } = useRuntimeConfig().public;
</script>
